import React from 'react';

import { H3, Section } from './Layout';
import code from '../images/programming.svg';

export default () => {
  return (
    <Section>
      <div>
        <img src={code} alt="Taylor Fuqua Education" />
      </div>
      <div>
        <H3>Experience</H3>
        I'm currently working as a free-lance web developer. I've spent the previous 5 years working at CapTech
        Consulting and Booz Allen Hamilton as a front-end developer implementing solutions using JavaScript, CSS and
        HTML.
      </div>
    </Section>
  );
};



// WEBPACK FOOTER //
// ./src/components/Experience.js